var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2LivingRoomBis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.93 40.34a4.18 4.18 0 01-2.73 1H66V54h-4v-7H14v7h-4V41.34h-.2a4.18 4.18 0 114.2-4.2V43h48v-5.84A4.2 4.2 0 0166.2 33a4.75 4.75 0 011 .11c.35.085.685.216 1 .39a4.19 4.19 0 01.73 6.87v-.03zM18 37v2h40v-1.84a8.18 8.18 0 014-7v-5.5A2.638 2.638 0 0059.36 22H15.64A2.64 2.64 0 0013 24.64v5A8.21 8.21 0 0118 37z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Living_room_bis.e6a29812.svg";
export { SvgE2LivingRoomBis as ReactComponent };